module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-picker-field-widget"
  }, [_c('div', _vm._l((_vm.getRanges()), function(range) {
    return _c('div', [_c('div', {
      staticClass: "range-color-header-parts"
    }, [_c('span', {
      staticClass: "range-color-header-part title",
      domProps: {
        "textContent": _vm._s(range.label)
      }
    }), (_vm.isThisRange(_vm.selectedColor, range.key)) ? _c('span', {
      staticClass: "range-color-header-part color-summary",
      domProps: {
        "innerHTML": _vm._s(_vm.getSummary())
      }
    }) : _vm._e()]), _c('div', _vm._l((_vm.colorByRangekey(_vm.colorAFormated, range.key)), function(color, colorKey) {
      return (_vm.isVisible(colorKey, _vm.colorAFormated)) ? _c('label', {
        staticClass: "round-color-input",
        attrs: {
          "title": color.label,
          "for": ("colorA_" + colorKey)
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.colorASelected),
          expression: "colorASelected"
        }],
        attrs: {
          "type": "radio",
          "name": "colorA",
          "id": ("colorA_" + colorKey),
          "disabled": color.outOfStock
        },
        domProps: {
          "value": colorKey,
          "checked": _vm._q(_vm.colorASelected, colorKey)
        },
        on: {
          "change": function($event) {
            _vm.colorASelected = colorKey
          }
        }
      }), _c('div', {
        staticClass: "img",
        class: {
          'selected': (_vm.colorASelected === colorKey && !color.outOfStock)
        },
        style: ({
          'background': _vm.colorPictureStyleBackground(color.imageZoomUrl, color.outOfStock)
        })
      }, [((_vm.colorASelected === colorKey && !color.outOfStock)) ? _c('div', {
        staticClass: "check-mark"
      }) : _vm._e()])]) : _vm._e()
    }))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-284ae12e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_unit/abTest/volet-roulant/VrColorPickerFieldWidget.vue
// module id = 339
// module chunks = 1